// extracted by mini-css-extract-plugin
module.exports = {"acceleration":"useHero_acceleration__2GemQ","component":"useHero_component__wS_vS"};